import React, { createContext, useContext, useMemo, useState } from "react";

const defaultState = {
  user: null,           // { name, email, provider }
  walletCents: 0,       // saldo en céntimos
  lastSession: null,    // datos post-clase para pantalla resumen
};

const AppContext = createContext({ state: defaultState });

export const AppProvider = ({ children }) => {
  const [state, setState] = useState(defaultState);

  const login = (user) => setState((s) => ({ ...s, user }));
  const logout = () => setState({ ...defaultState });
  const topUp = (cents) => setState((s) => ({ ...s, walletCents: s.walletCents + cents }));
  const spend = (cents) => setState((s) => ({ ...s, walletCents: Math.max(0, s.walletCents - cents) }));
  const setLastSession = (payload) => setState((s) => ({ ...s, lastSession: payload }));
  const resetLocal = () => setState(defaultState);
  const contextValue = useMemo(() => ({
    state,
    login,
    logout,
    topUp,
    spend,
    setLastSession,
    resetLocal,
  }), [state]);

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
